import {AfterViewInit, Component, EventEmitter, Input, Output, TemplateRef, ViewChild} from '@angular/core';
import {NgbTooltip} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'ds-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss']
})
export class TooltipComponent implements AfterViewInit {

  @ViewChild('ngbTooltip', {static: true}) ngbTooltip: NgbTooltip;

  @Input() title: string;
  @Input() ariaLabel: string;
  @Input() ariaLabelledby: string;
  @Input() content: string | TemplateRef<any> = '';
  @Input() placement = 'auto';
  @Input() tooltipClass = 'text-start';
  @Output() ngbTooltipEvent = new EventEmitter<NgbTooltip>();
  ariaExpanded = false;

  ngAfterViewInit() {
    this.ngbTooltipEvent.emit(this.ngbTooltip);
  }

  /**
   * Spartacus catches all esc keydown events in a function and directs it to EscapeFocusService.handleEscape.
   * This function will event.preventDefault(); and event.stopPropagation(); which kills the escape event and
   * stops it from reaching the tooltip component.
   * A event.key === 'Esc' with stopPropagation is needed to close the tooltip as expected.
   * To make the tooltip close when a new one is opened event.key === 'Tab' is needed.
   * To make it work with the shift key as well, (keydown) is not an option.
   *
   * @param event keydown event
   * @param ngbTooltip ngbTooltip Element reference
   */
  closeTooltip(event: KeyboardEvent, ngbTooltip: NgbTooltip) {
    if (event.key === 'Tab' || event.key === 'Esc') {
      event.stopPropagation();
      ngbTooltip.close();
    }
  }
}
